import type { OrganizationsActions } from '../../actions/org/organizations';
import type { OrganizationActions } from '../../actions/org/organization';
import type { State as OrganizationState } from './organization';
import organizationReducer, { localStorePaths as organizationLocalStorePaths } from './organization';
import type { State as OrganizationsState } from './organizations';
import organizationsReducer from './organizations';

interface State {
    organization: OrganizationState;
    organizations: OrganizationsState;
}

const getDefaultState = (): State => ({
    organization: organizationReducer(undefined, null),
    organizations: organizationsReducer(undefined, null)
});

export default (state = getDefaultState(), action: OrganizationsActions | OrganizationActions): State => ({
    organization: organizationReducer(state.organization, action as OrganizationActions),
    organizations: organizationsReducer(state.organizations, action as OrganizationsActions)
});

export const localStorePaths = [...organizationLocalStorePaths];
